import type { ComponentStyleConfig } from "@chakra-ui/react";

export const CheckboxTheme: Partial<ComponentStyleConfig> = {
  baseStyle: {
    container: {
      py: 1,
      px: 3,
      w: "fit-content",
      fontSize: "1rem",
      borderRadius: "1000px",
      _hover: {
        ".chakra-checkbox__control": {
          borderColor: "brand.red.100",
        },
      },
    },
    control: {
      bg: "white",
      h: "1rem",
      w: "1rem",
      borderColor: "brand.black.100",
      borderWidth: "1px",
      borderRadius: 4,
      transition: "all 0.2s filter 0s",
      _checked: {
        bg: "brand.red.100",
        borderColor: "brand.red.100",
        _hover: {
          borderColor: "brand.red.110",
          bg: "brand.red.110",
        },
      },
      _indeterminate: {
        bg: "brand.red.100",
        borderColor: "brand.red.100",
        _hover: {
          bg: "brand.red.100",
          borderColor: "brand.red.100",
        },
      },
      _hover: {
        borderColor: "brand.red.110",
        bg: "brand.red.110",
      },
    },
  },
};
